import {Container} from "@mantine/core";

export function FormContainer(form: JSX.Element) {
    return (
        <><br/><Container>
            {form}
        </Container></>
    );
}